<template>
  <div>
    <form id="company-search-form" class="form-inline" @submit.prevent>
      <div class="input-group">
        <label v-if="portal == 'mycfm'" class="form-label">Company Name:</label>
        <input
          id="search-input"
          v-model.trim="query"
          type="search"
          class="form-control"
          placeholder="Search your company"
          @keyup.enter="searchCompany"
        />
        <span class="input-group-btn">
          <button
            v-if="portal == 'mycfm'"
            class="btn btn-sm btn-default border-none"
            type="button"
            :disabled="loading"
            @click="searchCompany"
          >
            <i class="fa fa-search" aria-hidden="true"></i
            ><span v-show="loading">&nbsp;<i class="fa fa-spinner fa-spin"></i></span>
          </button>
        </span>
      </div>
    </form>
    <company-list v-if="showCompanyList" :companies="companies" search-enabled :portal="portal" />
    <div v-if="regionVisibility">
      <br />
      <p v-if="companies.length > 0" class="region-msg">None of the above? Please select the region.</p>
      <p v-if="companies.length == 0" class="region-msg">
        Your company name did not match any of our existing companies or organizations. Please <br />
        select the region.
      </p>
      <select id="regions" v-model="region" class="form-control">
        <option value="" selected>Select Region</option>
        <option value="africa">Africa</option>
        <option value="americas">Americas</option>
        <option value="asia">Asia</option>
        <option value="china">China</option>
        <option value="europe">Europe</option>
        <option value="middle_east">Middle East</option>
      </select>
    </div>
    <br />
    <div v-if="region == 'africa' || region == 'europe' || region == 'middle_east'">
      <p class="region-msg">
        In order to process your request, please contact CFM Customer Support at: <br />
        <b>France: </b>+33 1 64 14 88 66 <br />
        <b>E-mail: </b><a href="mailto:cfm.csc@safrangroup.com">cfm.csc@safrangroup.com</a>
      </p>
    </div>
    <div v-if="region == 'americas' || region == 'asia' || region == 'china'" class="region-msg">
      <a href="#" class="text-underline" @click.prevent="addNewCompany">
        Please click here to register your company
      </a>
    </div>
  </div>
</template>
<script>
import companyList from "./CompanyList";
import { companySearch } from "@/services/endpointsService";
export default {
  components: {
    companyList
  },
  props: {
    portal: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      query: "",
      companies: [],
      showCompanyList: false,
      loading: false,
      region: "",
      regionVisibility: false
    };
  },
  methods: {
    searchCompany() {
      if (this.query) {
        this.loading = true;

        companySearch(this.query)
          .then(data => {
            this.companies = data.companyDetailsResponseList;
          })
          .catch(() => {})
          .finally(() => {
            this.showCompanyList = true;
            this.loading = false;
            this.region = "";
            this.regionVisibility = true;
          });
      }
    },
    addNewCompany() {
      // persist user email
      // used in page reload cases
      let userEmail = this.$store.state.user.user.email;
      sessionStorage.setItem("company-user-email", userEmail);

      //resetting all the store thus preventing the back button from browser.
      this.$store.dispatch("companyUser/clearUserDetails");
      this.$store.dispatch("files/clearFiles");
      this.$store.dispatch("mro/removeMRO");
      this.$store.dispatch("product/clearProducts");
      this.$store.dispatch("s3Docs/clearDocs");
      this.$store.dispatch("user/clearUser");
      this.$store.dispatch("company/clearCompany");

      this.$store.dispatch("companyUser/setEmail", userEmail);
      this.$router.push("company-registration");
    }
  }
};
</script>
<style lang="less" scoped>
.input-group-btn {
  width: auto;
}

#company-search-form {
  margin-bottom: 15px;

  #search-btn {
    width: 70px;
  }

  #search-input {
    width: 260px;
  }
}

.form-label {
  padding: 5px 5px 0px 0px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #313337;
  float: left;
}

.region-msg {
  clear: both;
  padding-top: 5px;
  padding-left: 5px;
  width: 570px;
  background-color: rgb(247, 248, 250);
  display: block;
}

.text-underline {
  text-decoration: underline;
}
</style>
